import { ref, computed } from 'vue'
import en from '../i18n/en'
import nl from '../i18n/nl'

const messages = { en, nl }
const locale = ref('en')

function getNestedValue(obj, path) {
  return path.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj)
}

export function useLocale() {
  const isEnglish = computed(() => locale.value === 'en')
  const isDutch = computed(() => locale.value === 'nl')

  function t(key, params) {
    const val = getNestedValue(messages[locale.value], key)
    if (val === undefined) return key
    if (!params) return val
    return Object.entries(params).reduce(
      (str, [k, v]) => str.replace(new RegExp(`\\{${k}\\}`, 'g'), v),
      val
    )
  }

  function setLocale(lang) {
    locale.value = lang
    document.documentElement.lang = lang
    try { localStorage.setItem('orch_lang', lang) } catch (e) { /* ignore */ }
  }

  function localePath(path) {
    if (locale.value === 'nl') {
      return path === '/' ? '/nl' : `/nl${path}`
    }
    return path
  }

  return { locale, isEnglish, isDutch, t, setLocale, localePath }
}
